import { render, staticRenderFns } from "./payment-order.vue?vue&type=template&id=b3d96eae&scoped=true&"
import script from "./payment-order.vue?vue&type=script&lang=ts&"
export * from "./payment-order.vue?vue&type=script&lang=ts&"
import style0 from "./payment-order.vue?vue&type=style&index=0&id=b3d96eae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d96eae",
  null
  
)

export default component.exports